import { render, staticRenderFns } from "./pointModal.vue?vue&type=template&id=1087e2f7&scoped=true&"
import script from "./pointModal.vue?vue&type=script&lang=js&"
export * from "./pointModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1087e2f7",
  null
  
)

export default component.exports